<script lang="ts">
	import {uqn} from './stores.js';
	import check from './check_random/check';
	import Textfield, {Input, Textarea} from '@smui/textfield';
	import Button, {Label, Icon} from '@smui/button';
	import Dialog, {Title, Content, Actions} from '@smui/dialog';
	//import Slider from '@smui/slider';
	import Slider from './slider';
	import FormField from '@smui/form-field';
	import Katex from './Katex.svelte';
	import QnPreview from './QnPreview.svelte';
	import uqnSplit from './functions/uqnSplit';
	import uqnJoin from './functions/uqnJoin';
	import RadioGroup from './RadioGroup.svelte';
	import SliderNonZero from './SliderNonZero.svelte';
	import random from './check_random/random';
	import Fraction from './functions/fractionClass';
	//import signAssign from './functions/signAssign';
	//import signUnassign from './functions/signUnassign.js';
	//import getRandomInt from './functions/getRandomInt';
	//import signAssign from './functions/signAssign';
	//import signUnassign from './functions/signUnassign';

	let simpleDialog;
	
	let aSlide: number;
	let bSlide: number;
	let cSlide: number;
	let _;
	
	// initialize
	let type = $uqn.toString()[0];
	let uqnInput = $uqn;
	let radioType = type;

	// reactive
	$: _ = updateFromType(radioType);
	$: _ = updateFromUQN($uqn);
	$: _ = updateSlider(aSlide, bSlide,cSlide);

	let options = [
		{value: "1", label: "\\displaystyle \\frac{\\mathrm{d}m}{\\mathrm{d}t} = a-bm", katex: true},
		{value: "3", label: "\\displaystyle \\frac{\\mathrm{d}m}{\\mathrm{d}t} = bm-a", katex: true}
	]

	function updateFromType(t:string){
		let oldT = $uqn.toString()[0]
		if ( t=='3' && ( oldT=="1" || oldT=="2" ) ){
			if (Math.random()<0.5){
				t='4';
			}
			uqnInput = random(Number(t));
			uqn.set(uqnInput);
		} else if ( t=='1' && ( oldT=="3" || oldT=="4" ) ){
			if (Math.random()<0.5){
				t='2';
			}
			uqnInput = random(Number(t));
			uqn.set(uqnInput);
		} 
	}
	
	function updateFromUQN(u:number){
		uqnInput = u;
		let [t,a,b,c] = uqnSplit(u);
		if (t < 3){
			radioType = "1";
		} else{
			radioType = "3";
		}
		aSlide = a;
		bSlide = b;
		cSlide = t%2==1? c : c+10;
	}

	function updateSlider(a1: number, b1:number,c1:number){
		let [t,a,b,c] = uqnSplit($uqn);
		console.log((t%2==1 && c1 != c), (t%2==2 && c1 != c+10), c1, c);
		if (c1==10){
			if (c==9){
				c1 = 11;
			} else{
				c1 = 9;
			}
			cSlide = c1;
		}
		if (a1 != a){
			uqnInput = uqnJoin([t,a1,b,c])
			uqn.set(uqnInput);
		} else if (b1 != b){
			uqnInput = uqnJoin([t,a,b1,c])
			uqn.set(uqnInput);
		} else if (  (t%2==1 && c1 != c) || (t%2==0 && c1 != c+10) ){
			if (c1<10){
				if (t%2==0){
					t -= 1;
				}
			} else{
				if (t%2==1){
					t += 1;
				}
				c1 -= 10;
			}
			uqnInput = uqnJoin([t,a,b,c1])
			uqn.set(uqnInput);
		}
	}

	function over10 (b1:number): string {
		return new Fraction(b1,10).simplify().toString();
	}

	function uqnClick(){
		if (check(uqnInput)){
			uqn.set(uqnInput)
		} else{
			simpleDialog.open();
		}
	}	

</script>

<h2>Options</h2>
<hr>
<h3>UQN</h3>
<p>
	Retrieve a question by keying in a 4 digit UQN :
</p>
<Textfield class="shaped-outlined" variant="outlined" bind:value={uqnInput} label="UQN" type="number"/>
<Button on:click={uqnClick} variant="unelevated" class="button-shaped-round">
	<Label>Generate question</Label>
</Button>
<hr>
<h3>
	Question construction tools
</h3>
<p>First choose the general form of the question:</p>
<RadioGroup bind:radio={radioType} options={options}/>
<hr>
<QnPreview uqn={$uqn}/>
<hr>
<p>
	Use the sliders belows to choose different options to craft your own unique question:
</p>
<SliderNonZero bind:aSlide={aSlide} aMin={1}/>
<div>
	<FormField align="end" style="display: flex; width: 90%" >
		<Slider bind:value={bSlide} min={1} max={9} step={1} style="width:80%" discrete displayMarkers/>
		<span slot="label" style="padding-right: 12px; width: max-content; display: block;"><Katex math={"b="+($uqn.toString()[0]=="3"? over10(bSlide) : bSlide.toString())}/></span>
	</FormField>
</div>
<p>
The initial value of <Katex math="m"/> is <Katex math={"\\frac{ka}{b}"}/>. 
<div>
	<FormField align="end" style="display: flex; width: 90%" >
		<Slider bind:value={cSlide} min={1} max={19} step={1} style="width:80%" discrete displayMarkers hidden="hidden"/>
		<span slot="label" style="padding-right: 12px; width: max-content; display: block;"><Katex math={"k="+over10(cSlide)}/></span>
	</FormField>
</div>

<Dialog bind:this={simpleDialog}>
	<!-- Title cannot contain leading whitespace due to mdc-typography-baseline-top() -->
	<Title>Invalid UQN</Title>
	<Content>
		You have keyed an invalid UQN. Please try again.
	</Content>
	<Actions>
		<Button>
			<Label>OK</Label>
		</Button>
	</Actions>
</Dialog>
<hr>